import { focusRing } from '@repo/studio-design-system/utilities'
import * as SwitchPrimitive from 'primitives/switch'
import { tw } from 'utils/classnames'

type Size = 'small' | 'large'
const sizeClasses = {
  small: 'h-5 w-8 min-w-[20px]',
  large: 'h-6 w-10 min-w-[24px]',
}

const thumbSizeClasses = {
  small: 'h-4 w-4',
  large: 'h-5 w-5',
}

// TODO-TECH-DEBT(STU-10525): replace with @repo/studio-design-system-ui-rounded-switch.
export function Switch({
  className,
  size = 'small',
  ...props
}: SwitchPrimitive.SwitchProps & { size?: Size }) {
  return (
    <SwitchPrimitive.Root
      {...props}
      className={tw(
        'bg-theme_component_control_toggle_track_color-off-default hover:bg-theme_component_control_toggle_track_color-off-hover group-hover:bg-theme_component_control_toggle_track_color-off-hover focus:bg-theme_component_control_toggle_track_color-off-focus group-focus:bg-theme_component_control_toggle_track_color-off-focus active:bg-theme_component_control_toggle_track_color-off-active relative rounded-full outline-none',
        focusRing,
        props.checked &&
          "data-[state='checked']:bg-theme_component_control_toggle_track_color-on-default data-[state='checked']:hover:bg-theme_component_control_toggle_track_color-on-hover data-[state='checked']:focus:bg-theme_component_control_toggle_track_color-on-focus data-[state='checked']:group-hover:bg-theme_component_control_toggle_track_color-on-hover data-[state='checked']:group-focus:bg-theme_component_control_toggle_track_color-on-focus data-[state='checked']:active:bg-theme_component_control_toggle_track_color-on-active",
        props.disabled &&
          'bg-theme_component_control_toggle_track_color-off-disabled hover:bg-theme_component_control_toggle_track_color-off-disabled group-hover:bg-theme_component_control_toggle_track_color-off-disabled focus:bg-theme_component_control_toggle_track_color-off-disabled group-focus:bg-theme_component_control_toggle_track_color-off-disabled cursor-not-allowed',
        props.disabled &&
          props.checked &&
          "data-[state='checked']:bg-theme_component_control_toggle_track_color-on-disabled data-[state='checked']:hover:bg-theme_component_control_toggle_track_color-on-disabled data-[state='checked']:focus:bg-theme_component_control_toggle_track_color-on-disabled data-[state='checked']:group-hover:bg-theme_component_control_toggle_track_color-on-disabled data-[state='checked']:group-focus:bg-theme_component_control_toggle_track_color-on-disabled",
        sizeClasses[size ?? 'small'],
        className,
      )}
    >
      <SwitchPrimitive.Thumb
        className={tw(
          'bg-theme_component_control_toggle_handle_color-default block translate-x-[2px] rounded-full transition-transform duration-200 ease-in-out will-change-transform',
          "data-[state='checked']:translate-x-[calc(100%_-_2px)]",
          thumbSizeClasses[size ?? 'small'],
          props.disabled && 'bg-theme_component_control_toggle_handle_color-disabled',
        )}
      />
    </SwitchPrimitive.Root>
  )
}
